import { HttpRequest, HttpResponse } from './interfaces';

export class WontIntercept extends Error {
  constructor() {
    super('Interceptor will not fetch');
  }
}

export class ProxyFetchFailed extends Error {
  request: HttpRequest;
  statusCode: number;

  constructor(httpRequest: HttpRequest, statusCode: number, message?: string) {
    super(message || 'Proxy failed to fetch');
    this.statusCode = statusCode;
    this.request = httpRequest;
  }
}

export class AgentFetchFailed extends Error {
  request: HttpRequest;
  statusCode: number;

  constructor(httpRequest: HttpRequest, statusCode: number, message?: string) {
    super(message || 'Agent failed to fetch');
    this.statusCode = statusCode;
    this.request = httpRequest;
  }
}

export class LocalAgentFetchFailed extends Error {
  request: HttpRequest;
  statusCode: number;

  constructor(httpRequest: HttpRequest, response: HttpResponse) {
    super('Local Agent failed to fetch');
    if (response.statusText) {
      this.message = `${this.message}: ${response.statusText}`;
    }
    this.statusCode = response.status;
    this.request = httpRequest;
  }
}

export class FetchFailed extends Error {
  request: HttpRequest;
  cause: Error | string;

  constructor(request: HttpRequest, cause: Error) {
    super('Failed to fetch request');
    this.request = request;
    this.cause = cause;
  }
}

export class InvalidPayload extends Error {
  request: HttpRequest;
  constructor(request: HttpRequest) {
    super('Invalid payload for request');
    this.request = request;
  }
}

export class InterceptorDisabled extends Error {
  interceptorDisabled: boolean;
  constructor() {
    super('Interceptor is disabled');
    this.interceptorDisabled = true;
  }
}
